import isValidEmailAddress from './isValidEmailAddress';

/**
 * Returns path after stripping any email address strings
 * @param urlPath is the browser url
 */
export const stripEmailAddressFromPath = (urlPath: string): string =>
    decodeURIComponent(urlPath)
        .split('/')
        .filter(pathItem => !isValidEmailAddress(pathItem))
        .map(encodeURIComponent)
        .join('/');
